import { render } from "./NavBar.vue?vue&type=template&id=5ec8678c&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=5ec8678c&scoped=true&lang=css"

import exportComponent from "/Users/dejth/Workspace/nakee-order-detail/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec8678c"]])

export default __exports__